import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bya786doke: FaireBrandEntity = {
  token: "b_bya786doke",
  type: "brand",
  name: "Love and Repeat",
  avatarUrl:
    "https://cdn.faire.com/fastly/c89b2d3d847a6ace06426b7d8715b82d409a50270271968d72dbd3669b06ac0d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d1f4cc0bbb8cf2299531b04abc637bb3e16a1f4234218c614ba318a84fd2698e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c89b2d3d847a6ace06426b7d8715b82d409a50270271968d72dbd3669b06ac0d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d1f4cc0bbb8cf2299531b04abc637bb3e16a1f4234218c614ba318a84fd2698e.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 70,
  rating: 4.9,
  reviewCount: 1808,
  isTopShop: true,
  isInsider: true,
  description:
    "We are based in the heart of Downtown Los Angeles.\nLove & Repeat prides itself in providing high-quality contemporary Accessories and essential items at affordable prices. We are committed to bringing a variety of styles to cater to the desires of every fashion-aware woman. Customer satisfaction is our top priority. We hope our customers LOVE AND REPEAT many products from us ❤️",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:28.649Z",
    importedBy: "entity-db-cli",
  },
};
